import NegotiationMessage from '@data/model/NewModals/LiveNegotiation/NegotiationMessage'
import API from '../api'
import postUrl from './paths'

export const createUserInteraction = ({ type, data, user_id, created_by, source_id, source = 'ENQUIRY', organisationId }) =>
	new Promise((resolve, reject) => {
		const _data = new NegotiationMessage({
			data: {
				summary: type === 'text' ? data : '',
				created_at: Date.now(),
				created_by,
				type,
			},
		}).setOffer(type === 'offer' ? data.toJS().items : null)

		API.post(postUrl.createUserInteraction, _data.toJS(), { user_id, source_id, source, removeDefault: true, organisationId })
			.then((response) => {
				resolve(response.data)
			})
			.catch((err) => reject(err))
	})

export const closeUserInteraction = ({ closedBy, user_id, source_id, source = 'ENQUIRY' }) =>
	new Promise((resolve, reject) => {
		API.post(postUrl.closeUserInteraction, {}, { user_id, source_id, source, closedBy })
			.then((response) => {
				resolve(response.data)
			})
			.catch((err) => reject(err))
	})

export const updateOffer = ({ isAccepted, user_id, source_id, source = 'ENQUIRY', updatedBy, organisationId }) =>
	new Promise((resolve, reject) => {
		API.post(postUrl.updateOffer, {}, { user_id, source_id, source, isAccepted, updatedBy, organisationId })
			.then((response) => {
				resolve(response.data)
			})
			.catch((err) => reject(err))
	})
